import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getViewProfile,
  updateProfile,
} from "../../../redux/slices/profileSlice";

const PrimarySpecialtyModal = ({
  show,
  onHide,
  value,
  onSave,
  shouldUpdateProfile = false,
  isApplyPage = false,
}) => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);

  const [specialty, setSpecialty] = useState("");
  const [error, setError] = useState("");

  // Load existing value
  // useEffect(() => {
  //   if (!show) return;

  //   const current = store?.profileItem?.data?.nurseProfile?.primary_specialty;

  //   if (current) {
  //     setSpecialty(current);
  //   }
  // }, [show, store?.profileItem]);
  useEffect(() => {
    if (!show) return;

    if (isApplyPage) {
      setSpecialty(value || "");
    } else {
      const current = store?.profileItem?.data?.nurseProfile?.primary_specialty;

      setSpecialty(current || "");
    }
  }, [show, value, isApplyPage, store]);

  // const handleSave = () => {
  //   if (!specialty.trim()) {
  //     setError("Primary specialty is required");
  //     return;
  //   }

  //   if (specialty.length > 255) {
  //     setError("Maximum 255 characters allowed");
  //     return;
  //   }

  //   if (isApplyPage) {
  //     // ✅ LOCAL UPDATE (Apply Job page)
  //     onSave(specialty);
  //     onHide();
  //   } else {
  //     // ✅ API CALL (Profile page)
  //     const formData = new FormData();

  //     formData.append(
  //       "name",
  //       store?.profileItem?.data?.name ||
  //         store?.profileItem?.data?.full_name ||
  //         "",
  //     );

  //     formData.append("primary_specialty", specialty);

  //     dispatch(updateProfile(formData));
  //   }
  // };
  const handleSave = () => {
    const trimmed = specialty.trim();

    if (!trimmed) {
      setError("Primary specialty is required");
      return;
    }

    if (trimmed.length > 255) {
      setError("Maximum 255 characters allowed");
      return;
    }

    if (isApplyPage) {
      // ✅ ALWAYS update local
      onSave(trimmed);

      // 🔥 ONLY call API if empty before
      if (shouldUpdateProfile) {
        const formData = new FormData();

        formData.append(
          "name",
          store?.profileItem?.data?.name ||
            store?.profileItem?.data?.full_name ||
            "",
        );

        formData.append("primary_specialty", trimmed);

        dispatch(updateProfile(formData));
      }

      onHide();
    } else {
      // ✅ Profile page → always API
      const formData = new FormData();

      formData.append(
        "name",
        store?.profileItem?.data?.name ||
          store?.profileItem?.data?.full_name ||
          "",
      );

      formData.append("primary_specialty", trimmed);

      dispatch(updateProfile(formData));
    }
  };
  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
    }
  }, [store?.actionFlag]);
  useEffect(() => {
    if (show) {
      // dispatch(getViewProfile());
    }
  }, [show, dispatch]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="md"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Enter your primary nursing specialty</h5>

        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="form-group">
          <label className="col-label">Primary Specialty</label>

          <Form.Control
            type="text"
            placeholder="Emergency Medicine"
            value={specialty}
            maxLength={255}
            onChange={(e) => {
              setSpecialty(e.target.value);
              setError("");
            }}
            className={`col-input ${error ? "is-invalid" : ""}`}
          />
        </div>

        {error && <div className="error-message mt-2">{error}</div>}

        <div className="text-center mt-4">
          <Button
            className="btn-primary px-4"
            onClick={handleSave}
            disabled={store?.isLoading || !specialty.trim()}
          >
            {store?.isLoading ? "Saving..." : "Save"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PrimarySpecialtyModal;
